// Generated file : do not modify
import WizardItem from '@/extend/classes/WizardItem';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Gestion des wizard
export default class Wizard  {
  // Identifiant unique
  public id: number;
  // Label du wizard
  public label: string;
  // Liste des pages
  public wizardItems: WizardItem[];
  // Profil
  public profil: number;
  // Module
  public module: string;
  // Actif
  public actif: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.label = '';
    this.wizardItems = [];
    this.profil = 0;
    this.module = '';
    this.actif = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Wizard): Wizard {
    const newWizard: Wizard = new Wizard();
    newWizard.id = obj.id;
    newWizard.label = obj.label;
    newWizard.wizardItems = JSON.parse(JSON.stringify(obj.wizardItems));
    newWizard.profil = obj.profil;
    newWizard.module = obj.module;
    newWizard.actif = obj.actif;
    newWizard.canUpdate = obj.canUpdate;
    newWizard.canDelete = obj.canDelete;
    newWizard.display = obj.display;
    newWizard.notifDefType = obj.notifDefType;
    return newWizard;
  }

  public toJsonWizard (): string {
    const json = {
      label: this.label,
      wizardItems: this.wizardItems,
      profil: this.profil,
      module: this.module,
      actif: this.actif,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromWizard (obj: Wizard): void {
    this.id = obj.id;
    this.label = obj.label;
    this.wizardItems = obj.wizardItems;
    this.profil = obj.profil;
    this.module = obj.module;
    this.actif = obj.actif;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareWizard (value: Wizard): boolean {
    return (this.toJsonWizard() == value.toJsonWizard());
  }

  public cloneWizard (): Wizard {
    return Wizard.fromJson(this);
  }

  public create (): Promise<Wizard> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/wizards/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromWizard(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<Wizard> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/wizards/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromWizard(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/wizards/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static showWizard (module: string): Promise<Wizard> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/wizards/showWizard/' + module, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Wizard.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Wizard> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Wizards/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Wizard.fromJson(listData.reccords[0] as Wizard);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(wizards: Wizard[]) {
  }
}
